<template>
<div class="detail_box">
  <div class="detail_box_top">
    <div class="detail_box_top_title">{{popup.p_title}}</div>
    <div class="detail_box_top_date">{{returnDate(popup.created_at)}}</div>
  </div>
  <div class="detail_box_center">
    <div class="detail_box_center_content" v-html="popup.p_content"></div>
  </div>
<!--  <div class="detail_box_bottom">-->
<!--    <button class="detail_box_bottom_backBtn" @click="backEvent">목록</button>-->
<!--  </div>-->
</div>
</template>

<script>

export default {
  name: "PopupDetailComponent",
  mixins: [],
  components: {},
  inject: [],
  provide() {
    return {}
  },
  props: {
    popupKey: [],
  },
  data() {
    return {
      popup: {}
    }
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {
    this.getPopup()
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    getPopup() {
      let params = {
        fi: 1,
        ip: 0,
        id: this.popupKey,
        isdi: 1,
      }
      try {
        this.$api.$popup.getPopup(params).then(res => res.Data.Result).then(res => {
          if (res.Info.type == 1) {
            this.popup = res.List[0];
          }
        })
      } catch (e) {
        console.log(e);
      }

    },
    backEvent() {
      this.$router.back();
    },
    returnDate(date = null) {
      if (!date) {
        return '';
      }
      return this.$moment(date).format('YYYY-MM-DD HH:mm')
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>